/* Naturyl — one-page invisible wire PDP engine. Claude, 23 Aug 2026.
   Runs on /collections/frontpage (the ad landing page) and on every wire PDP.
   Picking a shade swaps gallery, price, lengths, reviews and the URL in place. */
(function () {
  'use strict';

  var dataEl = document.getElementById('iw-data');
  if (!dataEl) return;

  var DATA, shades;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  shades = (DATA.shades || []).slice().sort(function (a, b) {
    if (a.rk !== b.rk) return a.rk - b.rk;
    return a.n.localeCompare(b.n);
  });
  if (!shades.length) return;

  var byHandle = {};
  shades.forEach(function (s) { byHandle[s.h] = s; });

  /* On the collection page the page itself is not a product, so CANONICAL is
     null: the URL is never rewritten and the accelerated-checkout button, which
     Shopify binds to the page's own product, never applies. */
  var CANONICAL = DATA.canonical || null;

  var start = byHandle[DATA.current] || shades[0];
  var state = { shade: start, tex: start.tex, variant: null, slide: 0 };

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    swatches: $('iwSwatches'), lens: $('iwLens'), lenHint: $('iwLenHint'),
    scale: $('iwScaleFill'), name: $('iwName'), colourVal: $('iwColourVal'), price: $('iwPrice'),
    was: $('iwWas'), save: $('iwSave'), from: $('iwFrom'), ratingTxt: $('iwRatingTxt'), track: $('iwTrack'),
    dots: $('iwDots'), thumbs: $('iwThumbs'), flags: $('iwFlags'), stock: $('iwStock'),
    stockTxt: $('iwStockTxt'), deliver: $('iwDeliver'), vid: $('iwVariantId'), atc: $('iwAtc'),
    atcTxt: $('iwAtcTxt'), atcAmt: $('iwAtcAmt'), dyn: $('iwDyn'), buyNow: $('iwBuyNow'), form: $('iw-form'),
    sel: $('iwSel'), selImg: $('iwSelImg'), selName: $('iwSelName'), selView: $('iwSelView'),
    sticky: $('iw-sticky'), stickyImg: $('iwStickyImg'), stickyName: $('iwStickyName'),
    stickySub: $('iwStickySub'), stickyPrice: $('iwStickyPrice'), stickyGo: $('iwStickyGo'),
    stickyMeta: $('iwStickyMeta'),
    added: $('iw-added'), addedImg: $('iwAddedImg'), addedName: $('iwAddedName'), addedSub: $('iwAddedSub')
  };

  /* ---------------------------------------------------------------- helpers */

  var LEN_HINT = {
    '12 inch - 90g': 'Shorter and subtle — sits around the shoulders and blends seamlessly with your own hair.',
    '14 inch - 100g': 'Our most popular length. Noticeably longer and fuller without being dramatic.',
    '16 inch - 110g': 'A real change in length — falls around the mid-back.',
    '18 inch - 120g': 'Full glam. Reaches the lower back or waistline.',
    'Lightweight 12 inch - 45g': 'Half the weight of the standard 12″. Made for fine, thinning or shorter hair.'
  };
  var LEN_FILL = { '12 inch - 90g': 25, '14 inch - 100g': 48, '16 inch - 110g': 72, '18 inch - 120g': 100, 'Lightweight 12 inch - 45g': 25 };

  function thumbUrl(u) { return u ? u.replace('width=900', 'width=180') : u; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function lenLabel(t) {
    var lw = t.indexOf('Lightweight') === 0;
    var m = t.match(/(\d+)\s*inch\s*-\s*(\d+)g/i);
    if (!m) return { main: t, sub: '' };
    return { main: (lw ? 'Lightweight ' : '') + m[1] + '″', sub: m[2] + 'g' + (lw ? ' · fine hair' : '') };
  }

  function money(pence) { return '£' + (pence / 100).toFixed(2).replace(/\.00$/, ''); }

  function stars(r) {
    var full = Math.round(r);
    return '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
  }

  function heroOf(s) {
    var m = s.im && s.im[0];
    if (!m) return s.sw;
    return m.k === 'i' ? m.s : m.p;
  }

  function deliveryEstimate() {
    var d = new Date();
    if (d.getHours() >= 13) d.setDate(d.getDate() + 1);
    var added = 0;
    while (added < 3) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  /* ------------------------------------------------------------- swatch grid */

  function visibleShades() {
    return shades.filter(function (s) { return s.tex === state.tex; });
  }

  function renderSwatches() {
    els.swatches.innerHTML = visibleShades().map(function (s) {
      var cur = s.h === state.shade.h;
      var oos = !s.av;
      return '<a class="iw-sw' + (oos ? ' oos' : '') + '" href="' + s.u + '" data-h="' + s.h + '"' +
        ' aria-current="' + (cur ? 'true' : 'false') + '" title="' + esc(s.n) + (oos ? ' — sold out' : '') + '">' +
        '<figure><img src="' + s.sw + '" alt="' + esc(s.n) + ' invisible wire extension hair colour" loading="lazy" width="80" height="80"></figure>' +
        '<span class="tick" aria-hidden="true">✓</span>' +
        '<span class="nm">' + esc(s.n) + '</span></a>';
    }).join('');
  }

  /* ------------------------------------------------------------ media gallery */

  function slideHtml(m, i) {
    var eager = i === 0 ? ' fetchpriority="high"' : ' loading="lazy"';
    if (m.k === 'i') {
      return '<figure><img src="' + m.s + '" alt="' + esc(m.a) + '" width="900" height="900"' + eager + '></figure>';
    }
    /* video slides stay as a poster + play button until tapped, so nothing
       heavy loads for a shade the shopper may never look at */
    var payload = m.k === 'y' ? ' data-yt="' + esc(m.e) + '"' : ' data-mp4="' + esc(m.s) + '"';
    var shadeTag = (m.a && m.a.indexOf('Shade shown') === 0)
      ? '<span class="iw-shade-tag" style="position:absolute;right:10px;bottom:16px;z-index:2;background:rgba(26,27,24,.78);color:#fff;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;padding:5px 11px;border-radius:999px;pointer-events:none;">' + esc(m.a) + '</span>' : '';
    return '<figure class="iw-vid" style="position:relative;"' + payload + '>' +
      '<img src="' + m.p + '" alt="' + esc(m.a) + '" width="900" height="900"' + eager + '>' +
      shadeTag +
      '<button type="button" class="iw-play" aria-label="Play video"><span></span></button></figure>';
  }

  function renderMediaTrack() {
    els.track.innerHTML = state.shade.im.map(slideHtml).join('');
    els.track.scrollLeft = 0;
    state.slide = 0;
  }

  function renderMediaChrome() {
    var s = state.shade;
    els.dots.innerHTML = s.im.map(function (_, i) { return '<i class="' + (i === 0 ? 'on' : '') + '"></i>'; }).join('');
    els.thumbs.innerHTML = s.im.map(function (m, i) {
      var src = m.k === 'i' ? thumbUrl(m.s) : thumbUrl(m.p);
      return '<button type="button" data-i="' + i + '" aria-current="' + (i === 0) + '" aria-label="Image ' + (i + 1) + '"' +
        (m.k === 'i' ? '' : ' class="has-vid"') + '><img src="' + src + '" alt="" loading="lazy"></button>';
    }).join('');
    els.flags.innerHTML = (s.tex === 'wave' ? '<span class="iw-flag iw-flag--soft">Beach wave</span>' : '') +
      '<span class="iw-flag iw-flag--soft">Free colour exchange</span>';
  }

  function renderMedia() { renderMediaTrack(); renderMediaChrome(); }

  function syncDots() {
    var i = Math.round(els.track.scrollLeft / Math.max(1, els.track.clientWidth));
    if (i === state.slide) return;
    state.slide = i;
    [].forEach.call(els.dots.children, function (d, j) { d.className = j === i ? 'on' : ''; });
    [].forEach.call(els.thumbs.children, function (b, j) { b.setAttribute('aria-current', String(j === i)); });
  }

  els.track.addEventListener('click', function (e) {
    var fig = e.target.closest('.iw-vid');
    if (!fig || fig.dataset.playing) return;
    fig.dataset.playing = '1';
    if (fig.dataset.yt) {
      fig.innerHTML = '<iframe src="https://www.youtube.com/embed/' + fig.dataset.yt +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="Naturyl invisible wire extension video" ' +
        'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    } else {
      fig.innerHTML = '<video src="' + fig.dataset.mp4 + '" controls autoplay playsinline></video>';
    }
  });

  /* ---------------------------------------------------------------- lengths */

  function renderLengths(keepTitle) {
    var s = state.shade;
    var want = keepTitle || (state.variant && state.variant.t);
    var pick = null;
    if (want) pick = s.vs.filter(function (v) { return v.t === want && v.a; })[0];
    if (!pick) pick = s.vs.filter(function (v) { return v.a; })[0] || s.vs[0];
    state.variant = pick;

    els.lens.innerHTML = s.vs.map(function (v) {
      var l = lenLabel(v.t);
      var lw = v.t.indexOf('Lightweight') === 0;
      return '<button type="button" class="iw-len' + (lw ? ' wide' : '') + '" data-t="' + esc(v.t) + '"' +
        ' aria-pressed="' + (v.id === pick.id) + '"' + (v.a ? '' : ' disabled') + '>' +
        '<b>' + l.main + '</b><i>' + l.sub + '</i><em>' + money(v.p) + '</em></button>';
    }).join('');

    els.lenHint.textContent = LEN_HINT[pick.t] || '';
    els.scale.style.width = (LEN_FILL[pick.t] || 50) + '%';
  }

  /* ------------------------------------------------------------ price / cart */

  function renderBuy() {
    var s = state.shade, v = state.variant;

    els.name.textContent = s.n;
    els.colourVal.textContent = s.n;
    els.price.textContent = money(v.p);

    /* the confirmation card next to the swatches — the gallery is off-screen
       on a phone, so this is what tells her the photos above have changed */
    if (els.selName) els.selName.textContent = s.n;
    if (els.selImg) els.selImg.src = heroOf(s);

    if (v.cp && v.cp > v.p) {
      els.was.hidden = false; els.was.textContent = money(v.cp);
      els.save.hidden = false; els.save.textContent = 'Save ' + money(v.cp - v.p);
    } else { els.was.hidden = true; els.save.hidden = true; }

    /* shades with a cheaper option (the £89 Lightweight) lead with it, so the
       first price a cold visitor reads is the entry price, not the default */
    if (els.from) {
      var avail = s.vs.filter(function (x) { return x.a; });
      var minP = avail.length ? Math.min.apply(null, avail.map(function (x) { return x.p; })) : 0;
      if (minP && minP < v.p) { els.from.hidden = false; els.from.textContent = 'From ' + money(minP) + ' — see lengths below'; }
      else { els.from.hidden = true; }
    }

    if (s.rc > 0) {
      els.ratingTxt.textContent = s.r.toFixed(1) + ' · ' + s.rc + (s.rc === 1 ? ' review' : ' reviews') + ' for this shade';
      els.ratingTxt.previousElementSibling.textContent = stars(s.r);
    } else {
      els.ratingTxt.textContent = 'Rated 4.7 by 300+ customers';
      els.ratingTxt.previousElementSibling.textContent = '★★★★★';
    }

    els.vid.value = v.id;
    els.atcAmt.textContent = '— ' + money(v.p);
    els.atcTxt.textContent = v.a ? 'Add to cart' : 'Sold out';
    els.atc.disabled = !v.a;

    if (!v.a) {
      els.stock.className = 'iw-stock low';
      els.stockTxt.textContent = 'Sold out in this length — try another length or shade';
      els.deliver.textContent = '';
    } else if (v.q > 0 && v.q <= 12) {
      els.stock.className = 'iw-stock low';
      els.stockTxt.textContent = 'Only ' + v.q + ' left in this shade and length';
      els.deliver.innerHTML = 'FREE tracked UK delivery on this order — estimated arrival <b>' + deliveryEstimate() + '</b>';
    } else {
      els.stock.className = 'iw-stock';
      els.stockTxt.textContent = 'In stock at our UK warehouse';
      els.deliver.innerHTML = 'FREE tracked UK delivery on this order — estimated arrival <b>' + deliveryEstimate() + '</b>';
    }

    var onCanonical = CANONICAL && s.h === CANONICAL;
    if (els.dyn) els.dyn.style.display = onCanonical ? '' : 'none';
    if (els.buyNow) els.buyNow.hidden = !!onCanonical || !v.a;

    els.stickyImg.src = s.sw;
    els.stickyName.textContent = s.n;
    els.stickySub.textContent = lenLabel(v.t).main + ' · ' + lenLabel(v.t).sub;
    els.stickyPrice.textContent = money(v.p);
    els.stickyGo.disabled = !v.a;
  }

  /* the collection page keeps its own URL — every live ad points at it and it
     must not change; only a real product page rewrites to the shade shown */
  function syncUrl() {
    var s = state.shade;
    document.title = s.t + ' | Naturyl';
    if (!CANONICAL || !window.history || !history.replaceState) return;
    if (window.location.pathname !== s.u) history.replaceState({ h: s.h }, '', s.u + window.location.search + window.location.hash);
  }

  /* ---------------------------------------------------------------- reviews */
  /* templates/product.jm.liquid returns just the Judge.me widget for one shade.
     The mount lives in a later section, so it is looked up lazily — this script
     runs before that part of the page exists. */

  var reviewTimer = null;

  function loadReviews() {
    var mount = document.getElementById('iw-jm-mount');
    if (!mount) return;
    var h = state.shade.h;
    if (mount.getAttribute('data-handle') === h) return;
    fetch('/products/' + h + '?view=jm', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html == null || state.shade.h !== h) return;   /* shopper moved on mid-flight */
        mount.innerHTML = html;
        mount.setAttribute('data-handle', h);
        if (window.iwHydrateReviews) window.iwHydrateReviews();
      }).catch(function () {});
  }

  function queueReviews() {
    if (reviewTimer) clearTimeout(reviewTimer);
    reviewTimer = setTimeout(loadReviews, 350);
  }

  /* ------------------------------------------------------------------ select */

  function selectShade(handle) {
    var s = byHandle[handle];
    if (!s || s.h === state.shade.h) return;
    var keep = state.variant && state.variant.t;
    state.shade = s;
    state.tex = s.tex;
    document.querySelectorAll('#iw .iw-tex button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.tex === state.tex));
    });
    renderSwatches();
    renderMedia();
    renderLengths(keep);
    renderBuy();
    syncUrl();
    queueReviews();
    if (els.sel) {                       /* pulse so the change is noticed */
      els.sel.classList.remove('flash');
      void els.sel.offsetWidth;
      els.sel.classList.add('flash');
    }
  }

  /* ------------------------------------------------------------------ events */

  els.swatches.addEventListener('click', function (e) {
    var a = e.target.closest('.iw-sw');
    if (!a) return;
    e.preventDefault();
    selectShade(a.dataset.h);
  });

  if (els.selView) {
    els.selView.addEventListener('click', function () {
      els.track.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  els.lens.addEventListener('click', function (e) {
    var b = e.target.closest('.iw-len');
    if (!b || b.disabled) return;
    renderLengths(b.dataset.t);
    renderBuy();
  });

  document.querySelectorAll('#iw .iw-tex button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.tex === b.dataset.tex) return;
      state.tex = b.dataset.tex;
      document.querySelectorAll('#iw .iw-tex button').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x.dataset.tex === state.tex));
      });
      /* carry the shopper's colour across textures where the shade exists */
      var twin = shades.filter(function (s) { return s.tex === state.tex && s.n === state.shade.n; })[0];
      if (twin) { selectShade(twin.h); return; }
      renderSwatches();
    });
  });

  els.thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-i]');
    if (!b) return;
    els.track.scrollTo({ left: els.track.clientWidth * Number(b.dataset.i), behavior: 'smooth' });
  });

  els.track.addEventListener('scroll', syncDots, { passive: true });

  window.addEventListener('popstate', function () {
    var h = window.location.pathname.split('/').pop();
    if (byHandle[h]) selectShade(h);
  });

  /* ---------------------------------------------------------------- add to cart */

  var KIT_IDS = [42084535533740, 42084521050284, 48093162963261];

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count').forEach(function (n) {
          n.textContent = c.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } }));
      }).catch(function () {});
  }

  function openAdded() {
    var s = state.shade, v = state.variant, l = lenLabel(v.t);
    els.addedImg.src = s.sw;
    els.addedName.textContent = 'Invisible Wire Extension — ' + s.n;
    els.addedSub.textContent = l.main + ' · ' + l.sub + ' · ' + money(v.p);
    els.added.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function closeAdded() {
    els.added.classList.remove('on');
    document.body.style.overflow = '';
  }
  els.added.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) closeAdded(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAdded(); });

  function doAdd(btn, thenCheckout) {
    var v = state.variant;
    if (!v || !v.a) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    if (btn === els.atc) els.atcTxt.textContent = 'Adding…'; else btn.textContent = 'Adding…';
    addToCart([{ id: v.id, quantity: 1 }]).then(function () {
      if (thenCheckout) { window.location.href = '/checkout'; return; }
      return refreshCartCount().then(function () {
        openAdded();
        btn.disabled = false;
        if (btn === els.atc) els.atcTxt.textContent = 'Add to cart'; else btn.innerHTML = label;
      });
    }).catch(function () { window.location.href = '/cart'; });
  }

  els.form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(els.atc); });
  els.stickyGo.addEventListener('click', function () { doAdd(els.stickyGo); });
  if (els.buyNow) els.buyNow.addEventListener('click', function () { doAdd(els.buyNow, true); });

  if (els.stickyMeta) {
    els.stickyMeta.addEventListener('click', function () {
      els.swatches.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function bindKit(a) {
    if (!a) return;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var t = a.textContent;
      a.textContent = 'Adding…';
      addToCart(KIT_IDS.map(function (id) { return { id: id, quantity: 1 }; })).then(function () {
        a.textContent = '✓ Kit added — free at checkout';
        refreshCartCount();
      }).catch(function () { a.textContent = t; window.location.href = '/cart'; });
    });
  }
  bindKit(document.getElementById('iw-kit-add'));
  bindKit(document.getElementById('iwAddedKitAdd'));

  /* ------------------------------------------------------------- sticky bar */
  /* plain time-throttled scroll handler rather than requestAnimationFrame:
     rAF is suspended in background tabs, which leaves the bar stuck */

  /* Shopify's theme-preview bar is fixed to the bottom of the viewport and would
     sit right on top of this. Only ever present while previewing a draft. */
  function dodgePreviewBar() {
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (!pbar) return;
    var h = pbar.getBoundingClientRect().height;
    if (h > 0 && getComputedStyle(pbar).position === 'fixed') els.sticky.style.bottom = h + 'px';
  }

  var stickyAt = 0;
  function syncSticky() {
    stickyAt = new Date().getTime();
    var on = els.atc.getBoundingClientRect().bottom < 0;
    els.sticky.classList.toggle('on', on);
    els.sticky.setAttribute('aria-hidden', String(!on));
  }
  window.addEventListener('scroll', function () {
    if (new Date().getTime() - stickyAt < 80) return;
    syncSticky();
  }, { passive: true });
  window.addEventListener('resize', syncSticky);

  /* --------------------------------------------------------------- kick off */

  var initVariant = null;
  try {
    var q = new URLSearchParams(window.location.search);
    var qv = Number(q.get('variant'));
    if (qv) initVariant = (state.shade.vs.filter(function (v) { return v.id === qv; })[0] || {}).t || null;
    var qs = q.get('shade');
    if (qs && byHandle[qs] && qs !== state.shade.h) {
      state.shade = byHandle[qs];
      state.tex = state.shade.tex;
      renderMediaTrack();
      queueReviews();
    }
  } catch (e) {}

  document.querySelectorAll('#iw .iw-tex button').forEach(function (b) {
    b.setAttribute('aria-pressed', String(b.dataset.tex === state.tex));
  });
  renderSwatches();
  renderLengths(initVariant);
  renderBuy();
  renderMediaChrome();   /* the served HTML already holds this shade's media */
  syncSticky();
  dodgePreviewBar();
  setTimeout(dodgePreviewBar, 1500);   /* the preview bar mounts a beat late */
})();

